module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/proveedor/proveedor.component.html
// module id = ./src/app/productos/proveedor/proveedor.component.html
// module chunks = main